import type { WhiteSettings } from '@eip/engine';
import { Slider, Toggle } from './controls';
import { Section } from './Section';

export function WhitePanel({ white, onChange }: { white: WhiteSettings; onChange: (next: WhiteSettings) => void }) {
  const set = (patch: Partial<WhiteSettings>) => onChange({ ...white, ...patch });
  return (
    <Section id="white" title="White">
      <Toggle label="Underbase" checked={white.underbase} onChange={(v) => set({ underbase: v })} />
      {white.underbase && (<>
        <Slider label="Strength" value={white.strength} min={0} max={1} step={0.01} onChange={(v) => set({ strength: v })} />
        <Slider label="Floor" value={white.floor} min={0} max={1} step={0.01} onChange={(v) => set({ floor: v })} />
        <Slider label="Black hole" hint="Leaves no white under anything darker than this" value={white.blackHole} min={0} max={0.9} step={0.01} onChange={(v) => set({ blackHole: v })} />
        <Slider label="Choke" hint="Shrinks the white underbase so it hides behind the colours" value={white.chokePx} min={0} max={20} step={1} unit="px" onChange={(v) => set({ chokePx: v })} />
        <Slider label="Gamma" hint="Adjusts midtone brightness" value={white.gamma} min={0.2} max={5} step={0.1} onChange={(v) => set({ gamma: v })} />
      </>)}
      <Toggle label="Highlight white" checked={white.highlight} onChange={(v) => set({ highlight: v })} />
      {white.highlight && (<>
        <Slider label="Highlight threshold" value={white.highlightThreshold} min={0.5} max={0.99} step={0.01} onChange={(v) => set({ highlightThreshold: v })} />
        <Slider label="Highlight choke" value={white.highlightChokePx} min={0} max={20} step={1} unit="px" onChange={(v) => set({ highlightChokePx: v })} />
      </>)}
    </Section>
  );
}
